const menuNavConfig = {
  expoHallHiddenLocales: ['es', 'ja', 'ko', 'pt', 'ru', 'zh', 'zh-hans', 'zh-hant'],
  innovatorsLocales: ['en'],
}

export default menuNavConfig
